import { List, Text, Title } from "@mantine/core";
import LegalPageLayout from "./LegalPageLayout";

export default function PrivacyPolicy() {
  return (
    <LegalPageLayout title="Privacy Policy" lastUpdated="August 18, 2026">
      <Text size="sm">
        This Admin Panel ("the Platform") is an <strong>in-house tool built
        and operated by Thinkcloudly, for Thinkcloudly staff only</strong>.
        It is used internally to manage students, trainers, batches,
        invoices, and related operational data. The Platform is not a
        public product, is not offered to customers or any external
        organization, and no one outside Thinkcloudly is granted access to
        it. This Privacy Policy explains what information the Platform
        collects, how it is used internally, and how it is protected.
      </Text>

      <Title order={4}>1. Information We Collect</Title>
      <Text size="sm">
        The Platform stores and processes information required to operate
        our training programs, including:
      </Text>
      <List size="sm" spacing={4}>
        <List.Item>
          Account information for authorized users (name, work email,
          username, and role).
        </List.Item>
        <List.Item>
          Student and trainer records, such as contact details, batch
          enrollment, attendance, and progress data.
        </List.Item>
        <List.Item>
          Operational records including invoices, payments, remittances,
          packages, and referrals.
        </List.Item>
        <List.Item>
          Basic usage and log data (login timestamps, IP address, and
          actions taken within the Platform) for security and audit
          purposes.
        </List.Item>
      </List>

      <Title order={4}>2. How We Use This Information</Title>
      <List size="sm" spacing={4}>
        <List.Item>To operate, maintain, and improve the Platform.</List.Item>
        <List.Item>
          To manage student and trainer relationships, batches, sessions,
          and payments.
        </List.Item>
        <List.Item>
          To authenticate users and restrict access based on role.
        </List.Item>
        <List.Item>
          To maintain audit trails and investigate misuse or security
          incidents.
        </List.Item>
      </List>

      <Title order={4}>3. Data Access &amp; Sharing</Title>
      <Text size="sm">
        Access to the Platform is restricted to authorized Thinkcloudly
        employees, contractors, and trainers, and is governed by
        role-based permissions — it is never made available to students,
        customers, or any party outside Thinkcloudly. We do not sell or
        share the data stored in this Platform with third parties, except
        where required by law or through trusted service providers (such as
        hosting and authentication infrastructure) strictly to operate the
        Platform.
      </Text>

      <Title order={4}>4. Data Security</Title>
      <Text size="sm">
        We use reasonable administrative and technical safeguards — including
        authenticated access, encrypted connections, and restricted
        role-based permissions — to protect data stored in the Platform from
        unauthorized access, alteration, or disclosure.
      </Text>

      <Title order={4}>5. Data Retention</Title>
      <Text size="sm">
        Data is retained for as long as it is needed for operational,
        legal, or record-keeping purposes. Authorized administrators may
        request correction or removal of specific records where applicable.
      </Text>

      <Title order={4}>6. Your Rights</Title>
      <Text size="sm">
        Users with an account on this Platform may request access to,
        correction of, or removal of their personal information by
        contacting an administrator.
      </Text>

      <Title order={4}>7. Changes to This Policy</Title>
      <Text size="sm">
        This Privacy Policy may be updated from time to time to reflect
        changes in our practices. Continued use of the Platform after an
        update constitutes acceptance of the revised policy.
      </Text>

      <Title order={4}>8. Contact</Title>
      <Text size="sm">
        For questions about this Privacy Policy or how your data is
        handled, please contact your Thinkcloudly administrator.
      </Text>
    </LegalPageLayout>
  );
}
